import axios from "axios";

const API_URL = process.env.REACT_APP_API;

// Get auth token from localStorage
const getAuthToken = () => {
  const token = localStorage.getItem("token");
  return token ? `Bearer ${token}` : "";
};

export const createAchat = async (achatData) => {
  return await axios.post(`${API_URL}achats`, achatData, {
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
    },
  });
};
export const generateFacture = async (id) => {
  return await axios.get(`${API_URL}achats/${id}/facture`, {
    headers: {
      Authorization: getAuthToken(),
    },
    responseType: "blob", // This is crucial for PDF
  });
};
export const generateFacturePDF = async (id) => {
  return await axios.get(`${API_URL}achats/${id}/facture`, {
    headers: {
      Authorization: getAuthToken(),
    },
    responseType: "blob",
  });
};
export const getFournisseurs = async (organisationId, search = "") => {
  console.log(organisationId, search);
  const params = { organisation_id: organisationId };
  if (search) params.search = search;

  return await axios.get(`${API_URL}achats/fournisseurs`, {
    headers: { Authorization: getAuthToken() },
    params,
  });
};
export const getHistoriqueFournisseurs = async (id) => {
  return await axios.get(`${API_URL}achats/historiqueFournisseur/${id}`, {
    headers: { Authorization: getAuthToken() },
  });
};
export const getLastPurchasePrice = async (menuId) => {
  const params = { menu_id: menuId };
  return await axios.get(`${API_URL}achats/last-price`, {
    headers: { Authorization: getAuthToken() },
    params,
  });
};

export const validateAchat = async (achatId, statut = "recu", validator) => {
  try {
    const response = await axios.patch(
      `${API_URL}achats/${achatId}/validate`,
      { statut, validator },
      {
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error creating cash journal:", error);
    throw error;
  }
};
export const getAchats = async (organisationId, filters = {}) => {
  const params = { organisation_id: organisationId, ...filters };
  return await axios.get(`${API_URL}achats`, {
    headers: { Authorization: getAuthToken() },
    params,
  });
};

export const getAchatById = async (id) => {
  return await axios.get(`${API_URL}/achats/${id}`, {
    headers: { Authorization: getAuthToken() },
  });
};

export const updateAchat = async (id, achatData) => {
  return await axios.patch(`${API_URL}achats/${id}`, achatData, {
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
    },
  });
};

export const deleteAchat = async (id) => {
  return await axios.delete(`${API_URL}/achats/${id}`, {
    headers: { Authorization: getAuthToken() },
  });
};

export const marquerRecu = async (id, dateReception) => {
  return await axios.patch(
    `${API_URL}/achats/${id}/recu`,
    {
      date_reception: dateReception,
    },
    {
      headers: { Authorization: getAuthToken() },
    },
  );
};

export const marquerPaye = async (id, montant, modePaiement) => {
  return await axios.patch(
    `${API_URL}/achats/${id}/paye`,
    {
      montant,
      mode_paiement: modePaiement,
    },
    {
      headers: { Authorization: getAuthToken() },
    },
  );
};

export const getAchatsStats = async (organisationId, filters = {}) => {
  const params = { organisation_id: organisationId, ...filters };
  return await axios.get(`${API_URL}/achats/stats`, {
    headers: { Authorization: getAuthToken() },
    params,
  });
};

export const printFacture = async (achatId) => {
  return await axios.get(`${API_URL}/achats/${achatId}/facture`, {
    headers: { Authorization: getAuthToken() },
    responseType: "blob",
  });
};

// Add these to your existing AchatApi.js

export const getSupplierStatement = async (
  fournisseurId,
  dateDebut,
  dateFin,
) => {
  const params = {};
  if (dateDebut) params.date_debut = dateDebut;
  if (dateFin) params.date_fin = dateFin;

  return await axios.get(
    `${API_URL}achats/fournisseurs/${fournisseurId}/statement`,
    {
      headers: { Authorization: getAuthToken() },
      params,
    },
  );
};

export const getOverdueInvoices = async (organisationId) => {
  return await axios.get(`${API_URL}achats/overdue`, {
    headers: { Authorization: getAuthToken() },
    params: { organisation_id: organisationId },
  });
};

export const exportAchatsToExcel = async (organisationId, filters = {}) => {
  const params = { organisation_id: organisationId, ...filters };
  return await axios.get(`${API_URL}achats/export/excel`, {
    headers: { Authorization: getAuthToken() },
    params,
    responseType: "blob",
  });
};
// Add this to your AchatApi.js

export const createFournisseur = async (fournisseurData) => {
  return await axios.post(
    `${API_URL}achats/fournisseurs/create`,
    fournisseurData,
    {
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
    },
  );
};
// Add these to your AchatApi.js

// Get payments for a purchase
export const getPaymentsByAchat = async (achatId) => {
  return await axios.get(`${API_URL}achats/${achatId}/payments`, {
    headers: {
      Authorization: getAuthToken(),
    },
  });
};

// Record a payment for a purchase
export const recordPayment = async (achatId, paymentData) => {
  return await axios.post(`${API_URL}achats/${achatId}/payments`, paymentData, {
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
    },
  });
};

// Get supplier balance
export const getSupplierBalance = async (fournisseurId) => {
  return await axios.get(`${API_URL}fournisseurs/${fournisseurId}/balance`, {
    headers: {
      Authorization: getAuthToken(),
    },
  });
};

// Get supplier purchases

// Get supplier by ID
export const getFournisseurById = async (id) => {
  return await axios.get(`${API_URL}achats/fournisseurs/${id}`, {
    headers: { Authorization: getAuthToken() },
  });
};

// Update supplier
export const updateFournisseur = async (id, fournisseurData) => {
  return await axios.put(
    `${API_URL}achats/fournisseurs/${id}`,
    fournisseurData,
    {
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
    },
  );
};

// Delete supplier
export const deleteFournisseur = async (id) => {
  return await axios.delete(`${API_URL}achats/fournisseurs/${id}`, {
    headers: { Authorization: getAuthToken() },
  });
};

// Get supplier purchases
export const getSupplierPurchases = async (fournisseurId, organisationId) => {
  return await axios.get(
    `${API_URL}achats/fournisseurs/${fournisseurId}/purchases`,
    {
      headers: { Authorization: getAuthToken() },
      params: { organisation_id: organisationId },
    },
  );
};

// Get supplier payments
export const getSupplierPayments = async (fournisseurId, organisationId) => {
  return await axios.get(
    `${API_URL}achats/fournisseurs/${fournisseurId}/payments`,
    {
      headers: { Authorization: getAuthToken() },
      params: { organisation_id: organisationId },
    },
  );
};

// Get supplier stats
export const getSupplierStats = async (fournisseurId, organisationId) => {
  return await axios.get(
    `${API_URL}achats/fournisseurs/${fournisseurId}/stats`,
    {
      headers: { Authorization: getAuthToken() },
      params: { organisation_id: organisationId },
    },
  );
};
